module.exports = __webpack_public_path__ + "static/media/new-logo.851de5d3.svg";